
export default  [
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'group',
        icon: 'fa fa-arrow-circle-right',
        label: 'Informações Gerais',
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'text',
        field: 'nome',
        label: 'Nome',
        maxlength:100,
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
        type: 'text',
        field: 'nome_comercial',
        label: 'Nome Comercial',
        maxlength: 255,
        info:'Campo utilizado para fins de orçamentos',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
        type: 'select-tipo',
        tipo: 269,
        field: 'cat_esocial',
        valor:'descricao',
        multiple:false,
        label: 'Categoria - Tabela 23 do eSocial',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
        type: 'text',
        field: 'cod_metodologia',
        label: 'Código Metodologia',
        maxlength: 45,
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
        type: 'text',
        field: 'cod_cas',
        label: 'Código CAS',
        maxlength: 45,
        rules: ['']
    },
    // {
    //     class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    //     type: 'text',
    //     field: 'un_medida',
    //     label: 'Unidade de Medida',
    //     maxlength: 45,
    //     rules: ['required']
    // },
    {
        class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
        type: 'select-tipo',
        tipo: 290,
        field: 'id_tipo_unidade_medida',
        multiple:false,
        label: 'Unidade de Medida - eSocial',
        rules: []
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
        type: 'text',
        field: 'cod_esocial',
        label: 'Código eSocial (Tabela 24)',
        maxlength: 45,
        mask:'esocial',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'esocial_atividade_per',
        label: 'Atividades Periculosas, Instalubres ou Especiais - Tabela 28 do eSocial',
        option: {
            key: 'id',
            label: 'esocial',
            title:'nome',
            value: 'id'
        },
        info: 'Campo obrigatório para gerar o E-Social',
        multiple: true,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
        type: 'text',
        field: 'vazao',
        label: 'Vazão',
        maxlength: 45,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
        type: 'text',
        field: 'volume',
        label: 'Volume',
        maxlength: 45,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
        type: 'text',
        field: 'cod_amostrador',
        label: 'Código Tipo Amostrador',
        maxlength: 45,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'id_tab',
        label: 'Tabela Dinâmica',
        option: {
            key: 'id',
            label: 'tabela_dinamica',
            value: 'id'
        },
        info: 'Selecione o modelo de tabela que esse fator de risco pertence',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'textarea',
        field: 'desc_metodologia',
        label: 'Descrição Metodologia',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'textarea',
        field: 'amostra',
        label: 'Cuidados Amostra',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'textarea',
        field: 'desc_amostrador',
        label: 'Descrição Tipo Amostrador',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
        type: 'boolean',
        field: 'ativo',
        label: 'Ativo?',
        info:'Esse campo serve para inativar o fator de risco em outras partes no sistema.',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'group',
        icon: 'fa fa-arrow-circle-right',
        label: 'Laboratórios',
    },
];




// WEBPACK FOOTER //
// ./src/components/apps/web/fator-risco/_form/risco-cadastrar.js